// Hook to check if the current user has a specific permission
import { useUser } from "./UserProvider";

export const usePermissionCheck = () => {
  const { businessPlan } = useUser();

  return { checkPermission: businessPlan.checkPermission };
};
